export default __webpack_public_path__ + "static/devops_a1_cloud_baptiste_b-58a59c13bf633901c5e9255168a77b28.jpg";